import { Loadable } from '../..';
import { TariffFilter } from '../../../api/tariffApi';
import { BoltOnItem } from '../../../components/ui/input/DropdownInput';
import { HashMap } from '../../../constants';
import { LoadBoltOnsPayload } from '../../payload/loadRequests';
import {
  BoltOnState,
  DropdownItems,
  ExcludedProvisioningDaysState,
  SimProvisionState,
  TariffDropdownItems,
} from './simProvisionState';

/**
 * Gets default settings for the SIM provision state.
 */
export const getDefaultSimProvisionState = (): SimProvisionState => {
  return {
    boltOns: {},
    bundleTopupSizes: {},
    excludedProvisioningDays: getDefaultExcludedProvisioningDaysState(),
    tariffs: {},
    temporalBoltOns: {},
  };
};

/**
 * Gets the default bolt-ons filter
 */
export const getDefaultBoltOnsFilter = (filter: TariffFilter): LoadBoltOnsPayload => {
  return {
    accountId: filter.accountId,
    boltOns: '',
    networkId: filter.networkId,
    tariffNumber: undefined,
    isTemporal: false,
  };
};

/**
 * Gets the default available bolt-ons
 */
export const getDefaultAvailableBoltOns = (): Loadable<{
  byId: HashMap<BoltOnItem>;
  items: BoltOnItem[];
}> => {
  return {
    byId: {},
    isLoading: false,
    items: [],
  };
};

/**
 * Gets the default bolt-ons available for selection
 */
export const getDefaultBoltOnState = (filter: TariffFilter): BoltOnState => {
  return {
    availableBoltOns: getDefaultAvailableBoltOns(),
    selection: getDefaultBoltOnsFilter(filter),
  };
};

/**
 * Gets the default excluded provisioning days state
 */
export const getDefaultExcludedProvisioningDaysState = (): ExcludedProvisioningDaysState => {
  return {
    commandDefinitionIds: '',
    items: [],
    isLoading: false,
  };
};

/**
 * Gets the default dropdown items available for selection
 */
export const getDefaultDropdownItems = (): DropdownItems => {
  return {
    items: [],
    byId: {},
    isLoading: false,
  };
};

/**
 * Gets the default tariff dropdown items available for selection
 */
export const getDefaultTariffDropdownItems = (): TariffDropdownItems => {
  return {
    items: [],
    byId: {},
    isLoading: false,
  };
};
